export const mainRoutesNames = {
    CREATE_LANDING_ZONE: 'create-landing-zone',
    MANAGE_APP_REG: 'manage-app-reg',
    ABOUT: 'about',
    HOME: 'home'
};
